<template>
    <div>
        <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

        <div v-if="(!errors && !loading && (items.length == 0))" class="alert alert-warning" role="alert">
            {{ $root.text('There are no fonts', null, true) }}
        </div>
        <div v-if="(items.length > 0)" class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-10">{{ $root.text('Font', null, true) }}</div>
                                        <div class="col-1">{{ $root.text('Files', null, true) }}</div>
                                        <div class="col-1">&nbsp;</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row" :id="'font-row' + item.id" class="pb-0">
                                    <div class="row">
                                        <div class="col-10" style="padding-top: 3px">
                                            <h5 class="font-size-14 mb-0">
                                                <a href="#" class="text-dark mr-1" @click.prevent="toggleEditFont(item)">
                                                    {{ item.name }}
                                                </a>
                                                <span
                                                    v-for="file in item.files"
                                                    :key="file.id"
                                                    class="badge badge-soft-secondary font-size-12 mr-1 mb-1"
                                                >{{ getSubfamily(file) }}</span>
                                            </h5>
                                        </div>
                                        <div class="col-1" style="padding-top: 3px">
                                            {{ item.files.length }}
                                        </div>
                                        <div class="col-1 font-size-18 contact-links">
                                            <a
                                                v-if="!item.default"
                                                href="#"
                                                class="float-right"
                                                @click.prevent="toggleEditFont(item)"
                                            >
                                                <span
                                                    v-if="(font_details_open.indexOf(item.id) < 0)"
                                                    :key="'close-' + item.id"
                                                >
                                                    <i class="fa-regular fa-chevron-circle-down"></i>
                                                </span>
                                                <span v-else :key="'open-' + item.id">
                                                    <i class="fa-regular fa-chevron-circle-up"></i>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="row list-details-td mt-2">
                                        <div class="col-12 list-details" :id="'font-details' + item.id">
                                            <template-font-edit-form :data="item"></template-font-edit-form>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div style="position: relative; top: -20px; height: 40px; overflow: visible">
            <loading v-if="loading"></loading>
        </div>

        <div
            class="modal fade"
            id="template-font-add-form-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="template-font-add-form-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable">
                <template-font-add-form></template-font-add-form>
            </div>
        </div>

        <div
            class="modal fade"
            id="template-font-files-add-form-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="template-font-files-add-form-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <template-font-files-add-form></template-font-files-add-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                component_name: 'template-fonts',
                loading: false,
                errors: false,
                items: [],
                font_details_open: []
            }
        },
        mounted () {
            $('body').removeClass('login-body');
            this.getFonts();
        },
        methods: {
            getFonts: function () {
                if (!this.$root.hasPermission('templates_manage_fonts')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.loading = true;
                this.errors = false;
                this.items = [];
                this.font_details_open = [];

                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/template-fonts';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.items = response.data.fonts;
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            toggleEditFont: function (item) {
                if (this.font_details_open.indexOf(item.id) < 0) {
                    this.font_details_open.push(item.id);
                    $('#font-row' + item.id).addClass('highlighted');
                    $('#font-details' + item.id).slideDown('slow');
                } else {
                    var vm = this;
                    $('#font-details' + item.id).slideUp('slow', function () {
                        $('#font-row' + item.id).removeClass('highlighted');
                        for (var n = 0; n < vm.font_details_open.length; n++) { 
                            if (vm.font_details_open[n] == item.id) { 
                                vm.font_details_open.splice(n, 1); 
                            }
                        }
                    });
                }
            },
            getSubfamily: function (templateFile) {
                let subfamily = '';
                switch (templateFile.weight) {
                    case 'extraLight':
                        subfamily = this.$root.text('Extra light', null, true);
                        break;
                    case 'semiBold':
                        subfamily = this.$root.text('Semi bold', null, true);
                        break;
                    case 'extraBold':
                        subfamily = this.$root.text('Extra bold', null, true);
                        break;
                    default:
                        subfamily = this.$root.text(templateFile.weight, null, true);
                }
                if (templateFile.style == 'italic') {
                    subfamily += ' ' + this.$root.text('Italic', null, true);
                }

                return subfamily;
            }
        }
    }
</script>
